import { render, staticRenderFns } from "./oldchangeDetail.vue?vue&type=template&id=31038250&scoped=true"
import script from "./oldchangeDetail.vue?vue&type=script&lang=js"
export * from "./oldchangeDetail.vue?vue&type=script&lang=js"
import style0 from "./oldchangeDetail.vue?vue&type=style&index=0&id=31038250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31038250",
  null
  
)

export default component.exports